import type {
  TriviaConfig,
  TriviaPlaythrough,
  TriviaScore,
  TriviaScoreFormat,
  TriviaSelection,
} from "./trivia-types";

export function computeScore(
  playthrough: TriviaPlaythrough,
  selections: TriviaSelection[],
  config: TriviaConfig,
): TriviaScore {
  const maxPoints = playthrough.questions.reduce((sum, q) => sum + q.points, 0);
  const points = selections.reduce((sum, s) => sum + s.points, 0);
  const correctCount = selections.filter((s) => s.correct).length;
  const total = playthrough.questions.length;
  const percentage = maxPoints > 0 ? Math.round((points / maxPoints) * 100) : 0;

  return {
    points,
    maxPoints,
    correctCount,
    total,
    percentage,
    message: config.results.message,
  };
}

export function formatTriviaScore(
  score: TriviaScore,
  format: TriviaScoreFormat,
): string | undefined {
  switch (format) {
    case "fraction":
      return `${score.correctCount} / ${score.total}`;
    case "percent":
      return `${score.percentage}%`;
    case "points":
      return `${score.points} / ${score.maxPoints} points`;
    case "none":
      return undefined;
    default:
      return undefined;
  }
}
